import { getDefaultThreePlCustomerDetails } from '../actions/threePlCustomerActions'

const threePlCustomers = {
  list: {},
  fullList: {},
  detail: {},
  searchCustomerModal: false,
  modalCustomer: false,
  editModalCustomer: false,
  newForm: getDefaultThreePlCustomerDetails(),
  isLoading: {
    list: true,
    fullList: true,
    modal: false,
    form: false,
    deActivate: false,
    deleting: false,
  },
  isModalOpen: {
    deActivate: false,
  },
  confirmationModalData: {},
}
const ThreePlCustomers = function (state = threePlCustomers, action) {
  switch (action.type) {
    case 'TOGGLE_THREE_PL_CUSTOMER_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'TOGGLE_3pl_ADD_CUSTOMER_MODAL': {
      return {
        ...state,
        searchCustomerModal: action.value,
      }
    }

    case 'TOGGLE_THREE_PL_MODAL': {
      return {
        ...state,
        modalCustomer: action.value,
      }
    }
    case 'TOGGLE_THREE_PL_EDIT_MODAL': {
      return {
        ...state,
        editModalCustomer: action.value,
      }
    }
    case 'CHANGE_THREE_PL_DETAIL': {
      const newDetail = {
        ...state.detail,
        [action.key]: action.value,
      }

      return {
        ...state,
        detail: newDetail,
      }
    }

    case 'CHANGE_THREE_PL_EDIT_DETAIL': {
      const newDetail = {
        ...state.detail,
        [action.key]: action.value,
      }
      return {
        ...state,
        detail: newDetail,
      }
    }

    case 'UPDATE_THREE_PL_CUSTOMER_LIST': {
      return {
        ...state,
        list: action.list,
      }
      //   let newList = {}
      //   Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      //   return {
      //     ...state,
      //     list: {
      //       ...state.list,
      //       ...newList,
      //     },
      //   }
    }
    case 'UPDATE_THREE_PL_CUSTOMER_FULL_LIST': {
      return {
        ...state,
        fullList: action.list,
      }
      //   let newList = {}
      //   Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.fullList[key], ...value }))
      //   return {
      //     ...state,
      //     fullList: {
      //       ...state.fullList,
      //       ...newList,
      //     },
      //   }
    }
    case 'EMPTY_THREE_PL_EDIT_DETAIL': {
      return {
        ...state,
        detail: getDefaultThreePlCustomerDetails(),
      }
    }

    case 'TOGGLE_THREE_PL_CUSTOMER_DEACTIVATE_MODAL': {
      return {
        ...state,
        isModalOpen: {
          ...state.isModalOpen,
          deActivate: action.value,
        },
      }
    }

    case 'SET_DEACTIVATE_CONFIRMATION_MODAL_DATA': {
      return {
        ...state,
        confirmationModalData: action.value,
      }
    }

    default: {
      return state
    }
  }
}

export default ThreePlCustomers
